import React from "react";
import { tomos } from "../data/landing";
import { useCarousel } from "../hooks/useCarousel";
import { SectionHead } from "./SectionHead";
export function TomosCarousel() {
  const {
    index,
    containerRef,
    next,
    prev,
    goTo,
    onTouchStart,
    onTouchEnd
  } = useCarousel(tomos.length);
  return <section className="card" data-id="element-156" data-mp="3rc3iz9vcut05">
      <SectionHead kicker="CONHEÇA OS 5 TOMOS" title="Uma coleção completa, organizada por objetivo" subtitle="Cada tomo resolve uma necessidade do seu atendimento. Abra no exercício certo, imprima e aplique." data-id="element-157" data-mp="3rcvdsih4ompd" />
      <div className="car" ref={containerRef} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd} data-id="element-158" data-mp="nx7k96i4g9k2">
        <button className="arr prev" type="button" aria-label="Anterior" onClick={prev} data-id="element-159" data-mp="j1s9wojbovse">
          ‹
        </button>
        <div className="vp" data-id="element-160" data-mp="1bk5ydxirr5et">
          <div className="track" style={{
          transform: `translateX(-${index * 100}%)`
        }} data-id="element-161" data-mp="1blh8ef2t59ed">
            {tomos.map((t, i) => <div className="sl" key={t.number} aria-hidden={i !== index} data-id="element-162" data-mp="16segebdoi80a" data-mpi={i}>
                <div className="slimg" data-id="element-163" data-mp="2crz30m6ohs2">
                  <img src={t.img} alt={t.alt} loading="lazy" data-id="element-164" data-mp="2dtbp9iulcbw" />
                </div>
                <div className="slc" data-id="element-165" data-mp="7cmp71y4x3c2">
                  <div className="prow2" data-id="element-166" data-mp="3orjqqqb714a9">
                    <div className="av" data-id="element-167" data-mp="3oqidcf6pg5pd">{t.number}</div>
                    <div data-id="element-168" data-mp="3tpl7v5p26tj3">
                      <h3 className="pn" data-id="element-169" data-mp="3totoct8qkm96">{t.title}</h3>
                      <div className="st" data-id="element-170" data-mp="3fqd748d8zdcs">{t.count}</div>
                    </div>
                  </div>
                  <p className="qt" data-id="element-171" data-mp="3jrp08nvbygpq">{t.description}</p>
                  <span className="rb" data-id="element-172" data-mp="3jti4xxmduqv3">{t.tag}</span>
                </div>
              </div>)}
          </div>
        </div>
        <button className="arr next" type="button" aria-label="Próximo" onClick={next} data-id="element-173" data-mp="3ar8zvn9vvpp3">
          ›
        </button>
      </div>
      <div className="dots" data-id="element-174" data-mp="140j84dh1oaqg">
        {tomos.map((t, i) => <button key={t.number} className={`dot${i === index ? " active" : ""}`} type="button" aria-label={`Ir ao tomo ${t.number}`} aria-current={i === index} onClick={() => goTo(i)} data-id="element-175" data-mp="13yzu6tiv2bru" data-mpi={i} />)}
      </div>
    </section>;
}